import { render } from "./editDataList.vue?vue&type=template&id=6d4e2fc7&scoped=true"
import script from "./editDataList.vue?vue&type=script&lang=js"
export * from "./editDataList.vue?vue&type=script&lang=js"

import "./editDataList.vue?vue&type=style&index=0&id=6d4e2fc7&lang=scss&scoped=true"

import exportComponent from "/home/k8s/workspace/maxHu/nielsen-yq/prod/nielsen-yq-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4e2fc7"]])

export default __exports__